<template>
	<div>
		<div class='tip'>客服工作时间：工作日 8:30~11:30,13:00~17:30</div>
		<div class="page">
			<a :href="'tel:' + tel" class="tel-link">
		  <div class='service-ways' onTap="makePhoneCall">
			<img src="../assets/phoneCall.png" class='service-icon'/>
			<div class='service-main'>
			  <div class='service-title'>
				电话客服
			  </div>
			  <div class='service-addition'>
				电话：{{tel}}
			  </div>
			</div>
			<div class='pointer'>
			  <img src='../assets/icon_arrow.png'  class='point'/>
			</div>
		  </div>
			</a>
		  <div id='question-container'>
			<div id='question-title'>常见问题</div>

			<div v-for="(item,index) in QA" >
			  <div class='question' @click="showAnswer(index)" :data-index='index'>
				<div class='question-word'>{{item.name}}</div><img :src='item.open?require("../assets/up.png"):require("../assets/down.png")' class='question-icon' />
			  </div>
			  <div class='answer' v-show='item.open'>
				{{item.text}}
			  </div>
			</div>
		  </div>
		</div>
		<mt-tabbar v-model="selected" :fixed='true'>
		  <mt-tab-item id="home">
			<img slot="icon" src="../assets/index.png">
			首页
		  </mt-tab-item>
		  <mt-tab-item id="orderList">
			<img slot="icon" src="../assets/mask2.png">
			订单
		  </mt-tab-item>
		  <mt-tab-item id="customerService">
			<img slot="icon" src="../assets/order2.png">
			客服
		  </mt-tab-item>
		</mt-tabbar>
	</div>
</template>

<script>
import {getServiceInfo } from "@/data/api";
export default {
	data() {
		return{
			QA:[],
			tel:'',
			selected:'customerService'
		}
	},
	created() {
		ap.setNavigationBar({
			title:'客服',
		});
		this.$ba.trackPageview("/customerService");
		getServiceInfo().then((res)=>{
			if(res.data.code==200){
				this.tel=res.data.tel_phone;
				this.QA=res.data.items
			}
		})
	},
	methods:{
		showAnswer(e){
			console.log(e)
			if(this.QA[e].open){
			  this.QA[e].open=false;
			}else{
			  this.QA[e].open=true;
			}
		}
	},
	watch:{
		selected:function(val,oldVal){
				switch(val){
						case 'home':
								this.$router.replace('/');
						break;
						case 'orderList':
								this.$router.replace({ name: "orderList", query: { openId: this.openId } });
						break;
						case 'customerService':
								this.$router.replace('/customerService');
						break;
				}
		}
	}
}
</script>

<style scoped>
.page{
  background:rgba(247,247,247,1);
  padding: 2.667vw;
}
.service-ways{
  width: 94.667vw;
  height: 100px;
  margin-bottom:  10px;
  padding: 26px 5.333vw 26px 6.667vw;
  background: rgba(255,255,255,1);
  border-radius: 6px;
  display: flex;
  align-items: center;
}
.service-icon{
  width: 48px;
  height: 48px;
}
.service-main{
  display: inline-block;
  width: 40vw;
  margin-left: 20px;
}
.service-addition{
  margin-top: 5px;
  color:rgba(153,153,153,1);
  font-size:12px;
}
.tel-link{
	color:rgba(153,153,153,1);
	text-decoration: none;
}
.service-title{
  font-size:16px;
  font-weight: bold;
  color:rgba(51,51,51,1);
}
.pointer{
  flex: 1;
  text-align: right
}
#question-container{
  width: 94.667vw;
  background:rgba(255,255,255,1);
  border-radius:6px;
  height: auto;
  padding-left: 5.333vw;
  padding-right: 5.333vw;
  padding-bottom:8px;
	margin-bottom: 50px;
}
#question-title{
  height: 50px;
  line-height: 50px;
  color:rgba(153,153,153,1);
  font-size: 14px;
  border-bottom: 1px #EFEFEF solid;
}
.question{
  height:50px;
  line-height: 50px;
  font-size: 14px;
  color:rgba(51,51,51,1);
  display: flex;
  align-items: center;
}
.question-word{
  width: 79.467vw;
}
.question-icon{
  width: 16px;
}
.answer{
  padding: 16px 5.0667vw 16px 5.0667vw;
  color:rgba(102,102,102,1);
  font-size:13px;
  background:rgba(247,247,247,1);
  border-radius:6px;
}
.tip{
  width:100vw;
  height:50px;
  background:rgba(255,249,240,1);
  color:rgba(245,166,35,1);
  font-size:13px;
  line-height: 46px;
  text-align: center;
}
</style>
